import { render, staticRenderFns } from "./ProgramTimeline.vue?vue&type=template&id=b2525582&scoped=true&"
import script from "./ProgramTimeline.vue?vue&type=script&lang=js&"
export * from "./ProgramTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTimeline.vue?vue&type=style&index=0&id=b2525582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2525582",
  null
  
)

export default component.exports